export enum PLAY_VIDEO {
    /**
     * @value Restricted video
     * @description Test used when a video from a playlist is not available for the user
     */
    RESTRICTED_VIDEO = 'PLAY.RESTRICTED_VIDEO',
    /**
     * @value Video details tab list
     * @description aria-label for video details tab list
     */
    VIDEO_DETAILS_TABS = 'PLAY.VIDEO_DETAILS_TABS',
    /**
     * @value Encoding...
     * @description Video encoding status
     */
    VIDEO_ENCODING = 'PLAY.VIDEO_ENCODING',
    /**
     * @value Video format
     * @description Title for the new option "horizontal" or "vertical" videos
     */
    VIDEO_FORMAT = 'PLAY.VIDEO_FORMAT',
    /**
     * @value You don't have access to this video
     * @description Text used when a video from a playlist is not available for the user
     */
    VIDEO_NO_ACCESS = 'PLAY.VIDEO_VISIBILITY_RESTRICTED',
    /**
     * @value Could not upload video. You do not have sufficient rights to download this video.
     * @description Toast message displayed to the user if he tries to upload a video he is not allowed to download from an external source.
     */
    VIDEO_NO_DOWNLOADABLE = 'PLAY.VIDEO_NO_DOWNLOADABLE',
    /**
     * @value Transcript
     * @description Tab title for transcript segment list
     */
    VIDEO_TRANSCRIPT = 'PLAY.VIDEO_TRANSCRIPT',
    /**
     * @value Video uploaded
     * @description Progress state of video : uploaded
     */
    VIDEO_UPLOAD_PROGRESS_UPLOADED = 'PLAY.VIDEO_UPLOAD_PROGRESS_UPLOADED',
    /**
     * @value Uploading...
     * @description Progress state of video uploading
     */
    VIDEO_UPLOAD_PROGRESS_UPLOADING = 'PLAY.VIDEO_UPLOAD_PROGRESS_UPLOADING',
    /**
     * @value Do not close this window while the video is uploading.
     * @description Warning message when video is uplaoding
     */
    VIDEO_UPLOAD_PROGRESS_WARNING = 'PLAY.VIDEO_UPLOAD_PROGRESS_WARNING',
}
